export default {
  headerContent: {
    title: 'Hdi Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta DASK',
    description: {
      title:
        'HDI Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek?',
      content: [
        'Dask sigortası deprem sonucu oluşacak hasarların oluşturduğu masraflara karşı güvence altına alan zorunlu bir sigorta ürünüdür. Başvuru formunu doldurarak zorunlu deprem sigortanızı HDI Sigorta’dan tanzim edebilirsiniz.'
      ]
    },
    subContent: {
      title: 'DASK Sigorta Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Bina bedeli deprem sonucunda poliçede yazan teminatların gerçekleşmesi durumunda konutun yıkılması veya kısmi hasar alması durumunda sigortalıya ödenecek en üst bedeldir.',
          subList: null
        },
        {
          paragraph: 'Bu bedel bina yapı maliyetlerine göre hesaplanmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
